import {
  Accordion,
  HorizontalDivider,
  Image,
  Modal,
  Typography
} from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@hero/atoms';

import * as S from './style';

export const DonateToCharityModal = ({
  isOpen,
  setIsOpen,
  primaryButtonProps,
  secondaryButtonProps,
  descriptionTextKey = 'donateToCharityDesc',
  titleKey = 'charitableGiving'
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={setIsOpen}
      title={t(titleKey)}
      primaryButtonProps={primaryButtonProps}
      secondaryButtonProps={secondaryButtonProps}
    >
      <S.Content>
        <S.LeftCol>
          <Typography variant="body1Bold">{t('donateToCharityTitle')}</Typography>
          <Typography variant="body2">{t(descriptionTextKey)}</Typography>
          <HorizontalDivider $margin="16px 0" />
          <Accordion title={t('howItWorks')}>
            <S.Ul>
              <S.Li>{t('charityModalHowItWorksListItem1')}</S.Li>
              <S.Li>{t('charityModalHowItWorksListItem2')}</S.Li>
              <S.Li>{t('charityModalHowItWorksListItem3')}</S.Li>
              <S.Li>{t('charityModalHowItWorksListItem4')}</S.Li>
            </S.Ul>
          </Accordion>
        </S.LeftCol>
        <S.RightCol>
          <Card padding="24px">
            <Image name="charityModalIllustration" />
          </Card>
        </S.RightCol>
      </S.Content>
      <Typography variant="caption1" emphasis="weak">
        {t('charityReserveRightText')}
      </Typography>
    </Modal>
  );
};
